export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  tags: string[];
  date: string;
  image: string;
  author: string;
  readTime: number;
  isHot: boolean;
  isNew: boolean;
  content: string;
}

export const articles: Article[] = [
  {
    slug: '91-free-android-latest-2026',
    title: '91免费看片app安卓最新版下载与安装教程（2026年8月更新）',
    excerpt: '详细介绍91免费看片app安卓版的最新功能特性、下载安装步骤以及使用技巧，帮助安卓用户快速上手体验优质的免费看片服务。',
    category: 'android-app',
    tags: ['91免费看片app', '安卓下载', '免费看片软件安装'],
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20with%20video%20streaming%20app%20interface%20displayed%20on%20screen%2C%20clean%20minimalist%20setup%20on%20warm%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20warm%20coral%20accent%20details%2C%20elegant%20composition%2C%20professional%20tech%20product%20shot&width=800&height=500&seq=article-android-01&orientation=landscape',
    author: '91免费编辑部',
    readTime: 8,
    isHot: true,
    isNew: true,
    content: `<h2>91免费看片app安卓版简介</h2><p>91免费看片app是目前市场上最受欢迎的免费视频观看软件之一。安卓版本支持Android 5.0及以上系统，提供海量影视资源，涵盖电影、电视剧、综艺、动漫等多种类型。最新版本在播放流畅度和资源丰富度上都有显著提升。</p><h2>核心功能特色</h2><p><strong>海量资源库：</strong>聚合全网优质影视资源，每日更新，热门新片24小时内上线。</p><p><strong>多源切换：</strong>每个视频提供多个播放源，自动选择最优线路，卡顿时一键切换。</p><p><strong>高清画质：</strong>支持720P到4K多种清晰度选择，根据网络自动调整。</p><p><strong>离线下载：</strong>支持视频缓存下载，无网络环境下也能观看。</p><p><strong>纯净体验：</strong>界面简洁无广告弹窗，沉浸式观影体验。</p><h2>下载安装步骤</h2><p>第一步：在手机浏览器中打开91免费官网，找到安卓版下载页面。</p><p>第二步：点击下载按钮，等待APK安装包下载完成。</p><p>第三步：打开手机设置 &gt; 安全设置，开启"允许安装未知来源应用"。</p><p>第四步：点击下载好的APK文件进行安装。</p><p>第五步：安装完成后打开应用，即可开始免费看片。</p><h2>使用小技巧</h2><p>1. 在WiFi环境下预先下载想看的影片，外出时无需消耗流量。</p><p>2. 长按视频可选择投屏到电视观看，享受大屏体验。</p><p>3. 收藏功能可保存喜欢的影片，方便下次快速找到。</p>`,
  },
  {
    slug: '91-free-ios-install-guide',
    title: '91免费看片的app苹果版安装指南：iOS用户必看教程',
    excerpt: '为苹果用户提供91免费看片的app在iPhone和iPad上的完整安装教程，包括TestFlight和企业证书两种安装方式，让iOS用户也能轻松享受免费看片。',
    category: 'ios-app',
    tags: ['91免费看片的app', 'iOS下载', '苹果安装教程'],
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Apple%20iPhone%20displaying%20media%20streaming%20application%20interface%2C%20clean%20white%20background%20with%20subtle%20warm%20lighting%2C%20minimalist%20product%20photography%2C%20elegant%20silver%20device%2C%20professional%20tech%20showcase%2C%20soft%20shadows&width=800&height=500&seq=article-ios-01&orientation=landscape',
    author: '91免费编辑部',
    readTime: 10,
    isHot: false,
    isNew: true,
    content: `<h2>91免费看片的app iOS版概述</h2><p>91免费看片的app同样为苹果用户提供了优质的免费观影体验。iOS版本针对iPhone和iPad进行了深度优化，充分利用苹果设备的出色屏幕素质，提供极致的视觉享受。</p><h2>iOS安装方式详解</h2><h3>方式一：TestFlight安装（推荐）</h3><p>这是最推荐的安装方式，通过苹果官方的TestFlight平台分发，安全可靠。步骤如下：在Safari浏览器中打开91免费官网iOS下载页面，点击"TestFlight安装"按钮，系统会自动跳转到TestFlight应用，点击"安装"即可完成。注意：需要先在App Store下载TestFlight应用。</p><h3>方式二：企业证书安装</h3><p>适用于未上架TestFlight的版本。步骤如下：在Safari中打开下载链接，点击"安装"后，前往设置 &gt; 通用 &gt; VPN与设备管理，找到对应的企业证书并信任，返回桌面即可看到应用图标。</p><h2>使用体验</h2><p>iOS版91免费看片软件充分利用了苹果设备的硬件优势，支持HDR显示和空间音频，观影体验极为出色。软件界面采用iOS原生设计语言，操作流畅自然。</p>`,
  },
  {
    slug: 'top-5-free-video-apps-2026',
    title: '2026年免费视频软件推荐Top 5：流畅稳定看片首选',
    excerpt: '精选2026年市面上最优秀的5款免费视频软件，从资源丰富度、播放流畅度、界面体验等多维度进行详细评测对比，帮你找到最适合的免费看片工具。',
    category: 'latest-recommend',
    tags: ['免费视频软件下载', '看片app免费', '软件推荐'],
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Five%20modern%20smartphones%20arranged%20in%20a%20row%20displaying%20different%20video%20streaming%20interfaces%2C%20ranking%20comparison%20concept%2C%20clean%20studio%20lighting%2C%20professional%20product%20photography%2C%20warm%20neutral%20background%2C%20minimalist%20composition&width=800&height=500&seq=article-top5-01&orientation=landscape',
    author: '91免费编辑部',
    readTime: 12,
    isHot: true,
    isNew: false,
    content: `<h2>2026年免费视频软件市场概况</h2><p>随着流媒体技术的不断发展，2026年的免费视频软件市场更加繁荣。我们经过一个月的深度测试，从数十款软件中精选出5款体验最佳的产品，为你提供全面的选购参考。</p><h2>Top 1：星火视频</h2><p><strong>推荐指数：★★★★★</strong></p><p>资源最全面的一款免费视频软件，覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容。采用最新的P2P加速技术，播放流畅不卡顿。界面设计简洁大方，支持多设备同步观看记录。</p><h2>Top 2：极光影院</h2><p><strong>推荐指数：★★★★★</strong></p><p>以高清画质著称，支持4K超清播放。拥有独家资源库，很多院线新片都能第一时间看到。投屏功能做得特别好，与智能电视完美适配。</p><h2>Top 3：飞鱼视频</h2><p><strong>推荐指数：★★★★☆</strong></p><p>界面最漂亮的免费视频软件，用户体验极佳。AI智能推荐功能非常精准，总能推送到你喜欢的内容。适合注重使用体验的用户。</p><h2>Top 4：蓝光追剧</h2><p><strong>推荐指数：★★★★☆</strong></p><p>专注电视剧和综艺内容，追剧体验一流。自动跳过片头片尾功能好评如潮，连续播放不中断。弹幕功能活跃，追剧氛围浓厚。</p><h2>Top 5：万能播放器</h2><p><strong>推荐指数：★★★★☆</strong></p><p>最强本地播放能力，支持几乎所有视频格式。同时支持在线搜索和播放，是一个播放器和看片软件的结合体。适合对播放功能有高要求的用户。</p>`,
  },
  {
    slug: 'pc-free-video-software-setup',
    title: '电脑端免费看片软件安装教程：Windows和Mac全覆盖',
    excerpt: '详细的电脑端免费看片软件安装指南，覆盖Windows和Mac两大平台，从软件选择到安装配置，再到使用技巧，一站式解决电脑看片的所有需求。',
    category: 'pc-software',
    tags: ['91免费软件', '电脑端', '免费看片软件安装'],
    date: '2026-07-20',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20computer%20on%20a%20clean%20desk%20with%20video%20player%20software%20interface%20on%20screen%2C%20warm%20ambient%20lighting%2C%20minimalist%20workspace%20setup%2C%20professional%20tech%20photography%2C%20cozy%20home%20office%20atmosphere&width=800&height=500&seq=article-pc-01&orientation=landscape',
    author: '91免费编辑部',
    readTime: 9,
    isHot: false,
    isNew: false,
    content: `<h2>电脑端看片软件的优势</h2><p>相比手机端，电脑端看片拥有更大的屏幕、更好的音响效果和更强的性能支持。无论是办公间隙放松还是家庭影院体验，电脑端都是绝佳的观影选择。91免费为你整理了最全面的电脑端免费看片软件安装教程。</p><h2>Windows平台推荐软件</h2><p><strong>PotPlayer增强版：</strong>基于经典播放器魔改，集成在线搜索功能，支持几乎所有格式，播放效果一流。</p><p><strong>恒星播放器：</strong>国产优秀播放器，界面美观，资源丰富，支持弹幕和字幕在线匹配。</p><h2>Mac平台推荐软件</h2><p><strong>IINA增强版：</strong>Mac平台最优雅的播放器，原生M系列芯片优化，性能出色。</p><p><strong>恒星播放器Mac版：</strong>跨平台通用，Mac版同样出色，同步观看记录。</p><h2>安装步骤</h2><p>Windows：下载安装包 → 双击运行 → 选择安装路径 → 完成安装 → 打开软件搜索片源观看。</p><p>Mac：下载DMG文件 → 拖入Applications文件夹 → 首次打开需在系统偏好设置中允许运行 → 完成。</p>`,
  },
  {
    slug: '91-free-client-app-download',
    title: '91免费客户端的app全平台下载指南：手机电脑都能用',
    excerpt: '一站式91免费客户端的app下载指南，提供安卓版、苹果版、Windows版和Mac版的完整下载链接与安装说明，让你在任何设备上都能畅享免费看片。',
    category: 'latest-recommend',
    tags: ['91免费客户端的app', '全平台下载', '免费看片'],
    date: '2026-07-18',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20devices%20including%20smartphone%20tablet%20and%20laptop%20arranged%20harmoniously%2C%20all%20showing%20same%20app%20interface%2C%20cross-platform%20concept%2C%20warm%20studio%20lighting%2C%20clean%20minimalist%20composition%2C%20professional%20product%20photography&width=800&height=500&seq=article-client-01&orientation=landscape',
    author: '91免费编辑部',
    readTime: 7,
    isHot: true,
    isNew: false,
    content: `<h2>91免费客户端简介</h2><p>91免费客户端是91免费官方推出的全平台视频观看应用，支持安卓手机、苹果手机、Windows电脑和Mac电脑四大平台。客户端与网站内容同步，提供更流畅的原生应用体验。</p><h2>各平台下载方式</h2><h3>安卓客户端</h3><p>在官网下载最新APK安装包，支持Android 5.0及以上系统。安装前请开启"允许安装未知来源应用"权限。客户端大小约35MB，下载快速。</p><h3>苹果客户端</h3><p>通过TestFlight或企业证书方式安装，支持iOS 13.0及以上系统。安装后需在设置中信任企业证书。</p><h3>Windows客户端</h3><p>提供EXE安装包和绿色免安装版两种选择。支持Windows 7/10/11系统，绿色版解压即用。</p><h3>Mac客户端</h3><p>提供DMG安装包，支持macOS 10.14及以上系统，原生适配M系列芯片。</p><h2>客户端特色功能</h2><p>多设备同步观看记录、离线下载管理、智能片单推荐、一键投屏、弹幕互动等。客户端相比网页版加载更快，播放更稳定。</p>`,
  },
  {
    slug: 'how-to-choose-free-video-app',
    title: '看片app免费安装全攻略：如何选择适合自己的免费视频软件',
    excerpt: '面对众多免费看片软件不知如何选择？本攻略从设备兼容性、资源类型、播放体验、安全性等多个角度教你挑选最适合自己的免费视频软件。',
    category: 'tutorial',
    tags: ['看片app免费', '免费看片软件安装', '选择攻略'],
    date: '2026-07-15',
    image: 'https://readdy.ai/api/search-image?query=Person%20comparing%20multiple%20video%20apps%20on%20a%20tablet%20with%20thoughtful%20expression%2C%20warm%20cafe%20environment%2C%20soft%20natural%20light%20through%20window%2C%20cozy%20atmosphere%2C%20lifestyle%20photography%2C%20relaxed%20composition&width=800&height=500&seq=article-choose-01&orientation=landscape',
    author: '91免费编辑部',
    readTime: 11,
    isHot: false,
    isNew: false,
    content: `<h2>选择免费看片软件的核心要素</h2><p>市面上免费看片软件种类繁多，如何选到最适合自己的？我们从六个关键维度帮你梳理选择思路。</p><h2>一、设备兼容性</h2><p>首先要确认软件是否支持你的设备。安卓用户选择最广，苹果用户需注意安装方式，电脑用户要考虑系统版本。建议优先选择全平台支持的软件，方便多设备切换使用。</p><h2>二、资源丰富度</h2><p>资源库是看片软件的核心竞争力。好的软件应覆盖电影、电视剧、综艺、动漫等多种类型，并且更新及时。可以先试用看看自己想看的内容是否有资源。</p><h2>三、播放流畅度</h2><p>流畅度直接影响观影体验。选择具有多源切换功能的软件，在遇到卡顿时可以快速切换到备用线路。同时注意软件是否支持画质选择功能。</p><h2>四、界面与交互</h2><p>好的界面设计让使用更舒心。关注搜索功能是否好用、分类是否清晰、播放控制是否方便。一个设计良好的软件能大大提升日常使用体验。</p><h2>五、安全性</h2><p>安全是底线。选择91免费推荐的经过安全检测的软件，避免从不明渠道下载。安装时注意权限请求是否合理。</p><h2>六、更新维护</h2><p>活跃更新说明开发团队在持续维护。选择更新频繁的软件，功能和资源都更有保障。</p>`,
  },
  {
    slug: '91-free-watching-tips-2026',
    title: '91免费看片软件推荐：2026年稳定版长期使用报告',
    excerpt: '基于长达6个月的持续使用测试，为你带来91免费看片软件稳定版的深度使用报告，涵盖播放稳定性、资源更新速度和长期使用体验。',
    category: 'stable-version',
    tags: ['91免费看片软件推荐', '稳定版', '使用报告'],
    date: '2026-07-12',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tablet%20displaying%20video%20analytics%20and%20performance%20metrics%20dashboard%2C%20warm%20minimalist%20desk%20setup%20with%20coffee%20cup%2C%20professional%20tech%20review%20scene%2C%20soft%20morning%20light%2C%20clean%20composition&width=800&height=500&seq=article-stable-01&orientation=landscape',
    author: '91免费编辑部',
    readTime: 14,
    isHot: false,
    isNew: false,
    content: `<h2>测试背景</h2><p>为了给大家提供最真实的软件使用反馈，我们对91免费推荐的稳定版软件进行了为期6个月的持续使用测试。测试覆盖日常观影、高峰期播放、离线下载等多种使用场景。</p><h2>播放稳定性测试结果</h2><p>在6个月的测试周期内，稳定版软件的平均播放中断率仅为0.3%，远低于行业平均水平。即使在周末晚间等使用高峰期，多源切换功能也能保证99%以上的播放成功率。</p><h2>资源更新速度</h2><p>测试期间跟踪了100部热门影视资源的上线时间，稳定版软件平均在资源发布后8小时内即可观看，热门资源覆盖率达到95%。</p><h2>长期使用体验</h2><p>软件体积控制良好，6个月使用后缓存管理功能有效避免了存储空间膨胀。界面响应速度无明显下降，整体使用体验始终保持在良好水平。</p>`,
  },
  {
    slug: 'video-app-security-guide',
    title: '免费看片软件安装安全指南：保护你的设备与隐私',
    excerpt: '安装免费看片软件时如何保护个人信息和设备安全？本指南详细讲解安全下载渠道、权限管理和隐私保护措施，让你安心享受免费看片。',
    category: 'tutorial',
    tags: ['免费看片软件安装', '安全指南', '隐私保护'],
    date: '2026-07-08',
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20smartphone%20showing%20shield%20icon%20and%20privacy%20settings%2C%20warm%20minimalist%20background%2C%20professional%20tech%20illustration%20style%2C%20clean%20and%20trustworthy%20aesthetic%2C%20soft%20lighting&width=800&height=500&seq=article-security-01&orientation=landscape',
    author: '91免费编辑部',
    readTime: 9,
    isHot: false,
    isNew: false,
    content: `<h2>安全下载的三大原则</h2><p><strong>原则一：认准官方渠道。</strong>只从91免费官网或软件官方网站下载，避免使用搜索引擎随机找到的下载站。第三方下载站经常捆绑广告软件甚至恶意程序。</p><p><strong>原则二：核对文件信息。</strong>下载后核对文件大小、版本号是否与官方描述一致。如有异常请勿安装。</p><p><strong>原则三：安装前扫描。</strong>使用手机管家或杀毒软件对安装包进行安全扫描。</p><h2>权限管理建议</h2><p>安装看片软件时，注意审查权限请求。合理的权限包括：存储权限（用于缓存视频）、网络权限（用于在线播放）。不必要的权限如：通讯录、短信、通话记录等应拒绝。</p><h2>隐私保护措施</h2><p>建议使用游客模式观看，如需注册请使用独立密码。定期清理观看记录和缓存文件。不要在看片软件中填写真实姓名、身份证号等敏感个人信息。</p>`,
  },
  {
    slug: '91-free-android-tv-box',
    title: '91免费看片app电视盒子版：客厅大屏观影体验升级',
    excerpt: '91免费看片app推出电视盒子专用版本，让你的客厅秒变私人影院。支持主流电视盒子品牌，提供遥控器优化界面，全家共享大屏观影乐趣。',
    category: 'android-app',
    tags: ['91免费看片app', '电视盒子', '大屏观影'],
    date: '2026-07-05',
    image: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20large%20TV%20screen%20displaying%20video%20streaming%20app%20interface%2C%20cozy%20home%20theater%20setup%2C%20warm%20evening%20lighting%2C%20comfortable%20sofa%2C%20minimalist%20interior%20design%2C%20cinematic%20atmosphere&width=800&height=500&seq=article-tvbox-01&orientation=landscape',
    author: '91免费编辑部',
    readTime: 8,
    isHot: false,
    isNew: false,
    content: `<h2>电视盒子版介绍</h2><p>91免费看片app电视盒子版专为大屏观影优化，支持小米盒子、当贝盒子、天猫魔盒、腾讯极光等主流电视盒子品牌。界面采用遥控器操作逻辑，大字体大图标设计，老人小孩都能轻松使用。</p><h2>安装方法</h2><p>方法一：U盘安装。在电脑下载APK文件拷贝到U盘，插入电视盒子，通过文件管理器安装。</p><p>方法二：远程推送。手机和电视盒子连接同一WiFi，使用手机上的推送工具将APK发送到电视盒子安装。</p><p>方法三：应用市场。部分电视盒子应用市场可直接搜索下载。</p><h2>使用体验</h2><p>大屏观影的沉浸感是手机无法比拟的。4K超清画质在大屏幕上展现得淋漓尽致，配合家庭音响系统，观影体验堪比影院。遥控器操作简单直观，支持语音搜索功能。</p>`,
  },
  {
    slug: 'free-video-download-speed-optimize',
    title: '免费视频软件下载提速技巧：让下载速度飞起来',
    excerpt: '下载免费视频软件时速度太慢怎么办？本文分享多种实用提速技巧，包括DNS优化、下载工具推荐和时段选择建议，让91免费软件下载更快更稳定。',
    category: 'tutorial',
    tags: ['免费视频软件下载', '下载提速', '91免费软件'],
    date: '2026-06-30',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20representation%20of%20fast%20download%20speed%20with%20digital%20data%20streams%2C%20warm%20gradient%20background%2C%20modern%20technology%20concept%2C%20dynamic%20motion%20effect%2C%20clean%20futuristic%20aesthetic%2C%20professional%20illustration&width=800&height=500&seq=article-speed-01&orientation=landscape',
    author: '91免费编辑部',
    readTime: 7,
    isHot: false,
    isNew: false,
    content: `<h2>为什么下载速度慢？</h2><p>免费视频软件下载速度受多种因素影响：网络带宽、服务器距离、下载时段、DNS解析速度等。了解这些因素后，我们可以针对性地优化。</p><h2>提速技巧一：更换DNS</h2><p>将DNS服务器更换为114DNS（114.114.114.114）或阿里DNS（223.5.5.5），可显著提升域名解析速度，从而加快下载。</p><h2>提速技巧二：选择合适时段</h2><p>避开晚间8-11点的用网高峰期，选择凌晨或上午时段下载，速度通常可提升50%以上。</p><h2>提速技巧三：使用下载管理器</h2><p>推荐使用ADM或IDM等多线程下载工具，可以将下载速度提升3-5倍。</p><h2>提速技巧四：切换网络环境</h2><p>如果WiFi速度慢，可以尝试切换到5GHz频段WiFi或使用移动数据下载，有时候手机网络比家庭宽带更快。</p>`,
  },
];

export const getArticleBySlug = (slug: string): Article | null => {
  return articles.find((a) => a.slug === slug) || null;
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getHotArticles = (limit: number = 6): Article[] => {
  return articles.filter((a) => a.isHot).slice(0, limit);
};

export const getNewArticles = (limit: number = 6): Article[] => {
  return articles.filter((a) => a.isNew).slice(0, limit);
};

export const getRelatedArticles = (currentSlug: string, category: string, limit: number = 3): Article[] => {
  return articles.filter((a) => a.slug !== currentSlug && a.category === category).slice(0, limit);
};